import { useParams } from 'react-router-dom';

import { Step } from '../app/entities/step';

export const useCurrentStep = () => {
  const { stepId } = useParams() as { stepId: string };

  return Step.getOne(stepId);
};
